import { useEffect, useRef } from "react";
import { clearLocalStoragePreservingTheme } from '../utils/Utility';
import { useNavigate } from "react-router-dom";

const SessionExpiration = ({ children }) => {
  const timeoutDuration = 30 * 60 * 1000; // 30 minutes
  const timeoutRef = useRef();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearLocalStoragePreservingTheme();
    navigate("/sign-in");
  };

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(handleLogout, timeoutDuration);
  };

  useEffect(() => {
    // Set up event listeners for user activity
    window.addEventListener("mousemove", resetTimeout);
    window.addEventListener("keypress", resetTimeout);
    window.addEventListener("scroll", resetTimeout);
    window.addEventListener("click", resetTimeout);

    // Initialize the timeout when component mounts
    resetTimeout();

    return () => {
      // Clear timeout and remove event listeners on unmount
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      window.removeEventListener("mousemove", resetTimeout);
      window.removeEventListener("keypress", resetTimeout);
      window.removeEventListener("scroll", resetTimeout);
      window.removeEventListener("click", resetTimeout);
    };
    // eslint-disable-next-line
  }, []);

  return children;
};

export default SessionExpiration;
